module.exports = __webpack_public_path__ + "static/media/iconDelete.4dae962f.svg";